import { PROXY_SERVER } from "../../../_proxy";
export const API_PATH_ROOT = `${PROXY_SERVER}/api/v2/`;


export async function INTERNAL_API_V2_POST(endpoint, body, responseStatus, includeCredentials = true) {
    try {
        const response = await fetch(`${API_PATH_ROOT}${endpoint}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: includeCredentials ? 'include' : 'same-origin',
            body: JSON.stringify(body)
        });

        //if (!response.ok) { throw new Error(`Erro: ${response.status}`) }
        responseStatus?.(response.status);
        return await response.json();
    } catch (error) {
        console.error('Erro na requisição:', error);
        return null;
    }
}
export async function INTERNAL_API_V2_PUT(endpoint, body, responseStatus, includeCredentials = true) {
    try {
        const response = await fetch(`${API_PATH_ROOT}${endpoint}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            credentials: includeCredentials ? 'include' : 'same-origin',
            body: JSON.stringify(body)
        });
        //if (!response.ok) { throw new Error(`Erro: ${response.status}`) }
        responseStatus?.(response.status);
        return await response.json();
    } catch (error) {
        console.error('Erro na requisição:', error);
        return null;
    }
}

export async function INTERNAL_API_V2_DELETE(endpoint, body = null, responseStatus, includeCredentials = true) {
    try {
        const options = {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
            credentials: includeCredentials ? 'include' : 'same-origin',
        };
        if (body) { options.body = JSON.stringify(body) }
        const response = await fetch(`${API_PATH_ROOT}${endpoint}`, options);
        responseStatus?.(response.status);
        //if (!response.ok) { throw new Error(`Erro: ${response.status}`) }
        return await response.json();
    } catch (error) {
        console.error('Erro na requisição DELETE:', error);
        return null;
    }
}


export async function INTERNAL_API_V2_GET(endpoint, params = {}, responseStatus, includeCredentials = true) {
    try {
        // Monta a query string a partir dos parâmetros
        const queryString = new URLSearchParams(params).toString();
        const url = `${API_PATH_ROOT}${endpoint}${queryString ? `?${queryString}` : ''}`;

        const options = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
            credentials: includeCredentials ? 'include' : 'same-origin',
        };

        const response = await fetch(url, options);
        responseStatus?.(response.status);
        //if (!response.ok) { throw new Error(`Erro: ${response.status}`) }
        return await response.json();
    } catch (error) {
        // console.error('Erro na requisição GET:', error);
        return null;
    }
}
